/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthSupportPagedList } from '../models/auth-support-paged-list';
import { personalSearchAuthSupports } from '../fn/personal-space-subscription/personal-search-auth-supports';
import { personalSearchAuthSupports$Any } from '../fn/personal-space-subscription/personal-search-auth-supports-any';
import { PersonalSearchAuthSupports$Any$Params } from '../fn/personal-space-subscription/personal-search-auth-supports-any';
import { PersonalSearchAuthSupports$Params } from '../fn/personal-space-subscription/personal-search-auth-supports';
import { personalSearchTransactions } from '../fn/personal-space-subscription/personal-search-transactions';
import { personalSearchTransactions$Any } from '../fn/personal-space-subscription/personal-search-transactions-any';
import { PersonalSearchTransactions$Any$Params } from '../fn/personal-space-subscription/personal-search-transactions-any';
import { PersonalSearchTransactions$Params } from '../fn/personal-space-subscription/personal-search-transactions';
import { TransactionPagedList } from '../models/transaction-paged-list';


/**
 * All about personal space subscription
 */
@Injectable({ providedIn: 'root' })
export class PersonalSpaceSubscriptionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `personalSearchTransactions()` */
  static readonly PersonalSearchTransactionsPath = '/personalspace/transaction/search';

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchTransactions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchTransactions$Response(params?: PersonalSearchTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return personalSearchTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchTransactions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchTransactions(params?: PersonalSearchTransactions$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.personalSearchTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchTransactions$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchTransactions$Any$Response(params?: PersonalSearchTransactions$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return personalSearchTransactions$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchTransactions$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchTransactions$Any(params?: PersonalSearchTransactions$Any$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.personalSearchTransactions$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `personalSearchAuthSupports()` */
  static readonly PersonalSearchAuthSupportsPath = '/personalspace/auth-support/search';

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchAuthSupports$Response(params?: PersonalSearchAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return personalSearchAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personalSearchAuthSupports(params?: PersonalSearchAuthSupports$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.personalSearchAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personalSearchAuthSupports$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchAuthSupports$Any$Response(params?: PersonalSearchAuthSupports$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
    return personalSearchAuthSupports$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search my auth supports, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `personalSearchAuthSupports$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  personalSearchAuthSupports$Any(params?: PersonalSearchAuthSupports$Any$Params, context?: HttpContext): Observable<AuthSupportPagedList> {
    return this.personalSearchAuthSupports$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportPagedList>): AuthSupportPagedList => r.body)
    );
  }

}
